import { useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError, toISODate } from "@/lib/api";
import { StaffSelect } from "@/components/StaffSelect";

const empty = () => ({ client_name: "", client_phone: "", client_address: "", date: toISODate(new Date()), time: "", pickup_date: "", pickup_time: "", notes: "", assigned_to: "", floor: "" });

export function NewAppointmentDialog({ open, onOpenChange, onCreated }) {
  const [f, setF] = useState(empty);
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/appointments", { ...f, items: [], transport_cost: 0 });
      toast.success("Appuntamento creato");
      setF(empty());
      onOpenChange(false);
      onCreated(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg bg-white" data-testid="new-appointment-dialog">
        <DialogHeader><DialogTitle className="font-heading text-xl">Nuovo appuntamento</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Nome cliente *</Label><Input required value={f.client_name} onChange={set("client_name")} data-testid="new-appt-client-name-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Data visita *</Label><Input type="date" required value={f.date} onChange={set("date")} data-testid="new-appt-date-input" /></div>
            <div className="space-y-1.5"><Label>Ora</Label><Input type="time" value={f.time} onChange={set("time")} data-testid="new-appt-time-input" /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Data ritiro</Label><Input type="date" value={f.pickup_date} onChange={set("pickup_date")} data-testid="new-appt-pickup-date-input" /></div>
            <div className="space-y-1.5"><Label>Ora ritiro</Label><Input type="time" value={f.pickup_time} onChange={set("pickup_time")} data-testid="new-appt-pickup-time-input" /></div>
          </div>
          <p className="text-xs text-[var(--muted)] -mt-2">Ritiro da concordare? Lascia vuoto: lo fissi dopo e solo allora comparirà in Agenda.</p>
          <div className="space-y-1.5"><Label>Telefono</Label><Input type="tel" value={f.client_phone} onChange={set("client_phone")} data-testid="new-appt-phone-input" /></div>
          <div className="space-y-1.5"><Label>Indirizzo</Label><Input value={f.client_address} onChange={set("client_address")} data-testid="new-appt-address-input" /></div>
          <div className="space-y-1.5"><Label>Piano</Label><Input value={f.floor} onChange={set("floor")} placeholder="es. 3° piano" data-testid="new-appt-floor-input" /></div>
          <div className="space-y-1.5"><Label>Assegnato a</Label><StaffSelect value={f.assigned_to} onChange={(v) => setF({ ...f, assigned_to: v })} testid="new-appt-assigned-select" /></div>
          <div className="space-y-1.5"><Label>Note</Label><Textarea rows={2} value={f.notes} onChange={set("notes")} data-testid="new-appt-notes-input" /></div>
          <button className="btn-primary w-full h-11" disabled={saving} data-testid="new-appt-submit-button">{saving ? "Salvataggio..." : "Crea e apri preventivo"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
